import { Form, Root } from "../input/Input.js";
import "../input/index.js";
import { Label } from "../label/Label.js";
import "../label/index.js";
import { Item, Root as Root$1 } from "../radio-group/RadioGroup.js";
import "../radio-group/index.js";
import { DEFAULT_COLORS, NO_COLOR, getColorName } from "./utils.js";
import { Swatch, getFocusColor } from "./Swatch.js";
import { useEffect, useState } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
import { isValidHex } from "@givebutter/util";
//#region src/color-picker/ColorInput.tsx
const ColorPickerInput = ({ value: valueConsumer, allowNoColor = false, onValueChange, onClickColor: onClickConsumer, onChange: onChangeConsumer, onBlur: onBlurConsumer, colors: colorsConsumer, name, ...restInputProps }) => {
	const colors = [...[NO_COLOR].filter((_) => allowNoColor), ...colorsConsumer ?? DEFAULT_COLORS];
	const [value, setValue] = useState(valueConsumer ?? "");
	const [inputValue, setInputValue] = useState(value.replace("#", ""));
	useEffect(() => {
		if (valueConsumer) setValue(valueConsumer);
	}, [valueConsumer]);
	const updateColor = (color) => {
		const colorWithoutHash = color.replace("#", "");
		setValue(color);
		setInputValue(colorWithoutHash);
		onValueChange?.(color);
	};
	const onClickColor = (color) => (e) => {
		updateColor(color);
		onClickConsumer?.(e);
	};
	const onChangeInput = (e) => {
		const value = e.target.value.trim().replace("#", "");
		setInputValue(value);
		onChangeConsumer?.(e);
		if (value.length === 6 && isValidHex(value)) updateColor("#" + value);
	};
	const onBlurInput = (e) => {
		if (!isValidHex(inputValue)) setInputValue(value);
		onBlurConsumer?.(e);
	};
	return /* @__PURE__ */ jsxs("div", {
		className: "flex flex-col gap-1",
		children: [/* @__PURE__ */ jsxs(Root$1, {
			className: "flex flex-row flex-wrap gap-1.5",
			children: [colors.map((color) => {
				return /* @__PURE__ */ jsxs(Item, {
					id: color,
					value: color,
					className: "radix-state-checked:bg-unset h-fit w-fit shrink-0 rounded-md border-none p-0 ring-offset-2 outline-hidden focus-visible:ring-2 focus-visible:ring-current radix-state-checked:ring-2 radix-state-checked:ring-current",
					style: { color: getFocusColor(color) },
					onClick: onClickColor(color),
					checked: color === value,
					autoFocus: color === value,
					children: [/* @__PURE__ */ jsx("span", {
						className: "sr-only",
						children: getColorName(color)
					}), /* @__PURE__ */ jsx(Swatch, {
						color,
						className: "size-8 cursor-pointer rounded-md"
					})]
				}, color);
			}), /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsxs("div", {
				className: "flex flex-nowrap items-center",
				children: [
					/* @__PURE__ */ jsx("div", {
						className: "flex size-8 items-center justify-center rounded-lg input-left bg-gray-200",
						children: /* @__PURE__ */ jsx("p", {
							className: "text-gray-400",
							"aria-hidden": true,
							children: "#"
						})
					}),
					!name && /* @__PURE__ */ jsx(Label, {
						htmlFor: "color-input",
						className: "sr-only",
						children: "Custom color"
					}),
					/* @__PURE__ */ jsx(Root, {
						className: "h-8 input-right py-0",
						children: /* @__PURE__ */ jsx(Form, {
							onBlur: onBlurInput,
							onChange: onChangeInput,
							value: inputValue.replace("#", "").toUpperCase(),
							className: "h-8",
							name: name ?? "color-input",
							...restInputProps
						})
					})
				]
			}) })]
		}), /* @__PURE__ */ jsx("p", {
			className: "sr-only",
			children: getColorName(value) ?? "custom color"
		})]
	});
};
//#endregion
export { ColorPickerInput };
